import { Flame, Snowflake } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";
import { BOILER_BRANDS, AC_BRANDS } from "../constants";

const BrandCloud = ({ title, icon: Icon, accent, brands, testId }) => (
  <div data-testid={testId}>
    <div className="flex items-center gap-3 mb-6">
      <Icon className="w-5 h-5" style={{ color: accent }} />
      <h3 className="font-mono-tech text-xs uppercase tracking-[0.25em]" style={{ color: accent }}>
        {title}
      </h3>
      <span className="h-px flex-1 bg-white/10" />
    </div>
    <div className="flex flex-wrap gap-3">
      {brands.map((brand) => (
        <span
          key={brand}
          data-testid={`${testId}-brand-${brand.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="rounded-full border border-white/10 px-5 py-2.5 font-display text-sm md:text-base text-[#F1F5F9] transition-all duration-300 cursor-default hover:-translate-y-0.5"
          style={{ "--hover-accent": accent }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = accent;
            e.currentTarget.style.boxShadow = `0 0 20px ${accent}33`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          {brand}
        </span>
      ))}
    </div>
  </div>
);

export const Brands = () => (
  <section
    id="marche"
    data-testid="brands-section"
    className="py-24 md:py-32 bg-[#0A0D12] border-y border-white/10"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <FadeUp>
        <Eyebrow color="text-[#00D2FF]">Marche trattate</Eyebrow>
        <h1 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-4xl">
          Tutte le marche.
          <span className="text-[#94A3B8]"> Un solo numero da chiamare.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-[#94A3B8]">
          Assistenza, ricambi e manutenzione sui principali marchi presenti in
          Italia. Se la tua marca non è in elenco, chiamaci: molto probabilmente
          la trattiamo comunque.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16">
        <FadeUp delay={0.1}>
          <BrandCloud
            title="Caldaie"
            icon={Flame}
            accent="#FF6B00"
            brands={BOILER_BRANDS}
            testId="boiler-brands"
          />
        </FadeUp>
        <FadeUp delay={0.2}>
          <BrandCloud
            title="Condizionatori"
            icon={Snowflake}
            accent="#00D2FF"
            brands={AC_BRANDS}
            testId="ac-brands"
          />
        </FadeUp>
      </div>
    </div>
  </section>
);
